var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "dl",
    {
      staticClass:
        "icon-details-categories display-inline-flex flex-items-center flex-content-center flex-wrap",
      staticStyle: {
        "--margin-bottom": "0",
        "--padding-left": "0",
        gap: "var(--spacing-md)",
      },
    },
    [
      _c(
        "dt",
        {
          staticClass: "muted sr-only",
          staticStyle: {
            "--margin-bottom": "0",
            "font-weight": "var(--font-weight-normal)",
          },
        },
        [_vm._v("\n    Found in the following categories:\n  ")]
      ),
      _vm._v(" "),
      _vm._l(_vm.sampleCategories, function (category) {
        return _c(
          "dd",
          { key: category, staticStyle: { "--margin-bottom": "0" } },
          [
            _c(
              "site-link",
              {
                staticClass: "tag rounded blue",
                staticStyle: { "--link-decoration-line": "none" },
                attrs: { to: _vm.$category({ name: category }) },
                nativeOn: {
                  click: function ($event) {
                    return _vm.clickCategory(category)
                  },
                },
              },
              [_vm._v(_vm._s(category))]
            ),
          ],
          1
        )
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }